import { render, staticRenderFns } from "./OpenDepositStepper.vue?vue&type=template&id=10475f49"
import script from "./OpenDepositStepper.vue?vue&type=script&lang=js"
export * from "./OpenDepositStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports